import React, { useState } from 'react';
import { PencilSquareIcon } from '@heroicons/react/24/solid';

const UserTable = ({ users, handleEdit, handleToggleStatus, onBranchUserSelected }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="hidden md:block overflow-x-auto">
      <table className="min-w-full table-auto bg-white rounded shadow text-sm">
        <thead className="bg-[#293686] text-white uppercase text-left">
          <tr>
            <th className="p-2">Code</th>
            <th className="py-2">Branch</th>
            <th className="p-2">Name</th>
            <th className="p-2">Phone</th>
            <th className="p-2">Email</th>
            <th className="p-2">Status</th>
            <th className="p-2">Edit</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user, idx) => (
              <tr key={idx} className="border-t">
                <td className="p-2  text-[#E91C24] font-bold">
                  <div className="cursor-pointer" onClick={() => onBranchUserSelected(user)}>
                    {u(user.code)}
                  </div>
                </td>
                <td className="p-2">{u(user.branch?.name)}</td>
                <td className="p-2">{u(user.name)}</td>
                <td className="p-2">{user.phone}</td>
                <td className="p-2">{u(user.email)}</td>
                <td
                  className={`p-2 cursor-pointer hover:underline ${
                    user.is_active ? 'text-green-600' : 'text-red-500'
                  } font-medium`}
                  onClick={() => handleToggleStatus(user)}
                >
                  {user.is_active ? 'ACTIVE' : 'INACTIVE'}
                </td>
                <td className="p-2">
                  <button onClick={() => handleEdit(user)}>
                    <PencilSquareIcon className="h-5 w-5 text-blue-600 hover:text-blue-800" />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-gray-500 py-10">
                No users available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserTable;
